<template>
  <div>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        1.
        {{
          locales &&
          locales.properties &&
          locales.properties.dependant_leave_area
        }}
      </template>
      <ul class="form__list form__list-top">
        <li
          class="form__item form__item--1/4"
          v-html="
            locales &&
            locales.properties &&
            locales.properties.own_room_kitchen_surface
          "
        ></li>
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea['own_room'].surface"
            name="leaveArea[own_room][surface]"
            label=""
            @input="countDependantLeaveAreaPoints(leaveArea)"
            :IsExtraInfo="true"
          >
            <template slot="extra-info"> m<sup>2</sup> </template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.common_area_with_central_heating
          }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea['common_area'].surface"
            name="leaveArea[common_area][surface]"
            label=""
            @input="countDependantLeaveAreaPoints(leaveArea)"
            :IsExtraInfo="true"
          >
            <template slot="extra-info"> m<sup>2</sup> </template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.number_of_residents
          }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea['number_of_residents']"
            name="leaveArea[number_of_residents]"
            label=""
            @input="countDependantLeaveAreaPoints(leaveArea)"
          >
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.leave_area }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="leaveArea.total"
            name="leaveArea[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>

    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        2.
        {{
          locales &&
          locales.properties &&
          locales.properties.heated_private_rooms
        }}
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          <v-radios-public
            @input="countHeatingPoints"
            label=""
            name="heating[type]"
            v-model="heating.type.value"
            :options="{
              '0':
                locales &&
                locales.properties &&
                locales.properties.no_heating_or_electric,
              '1':
                locales && locales.properties && locales.properties.gas_heater,
              '2':
                locales &&
                locales.properties &&
                locales.properties.central_heating,
            }"
          >
          </v-radios-public>
        </li>
        <li
          class="form__item form__item--1/2"
          v-if="heating.type.value == 0 || heating.type.value == 1"
        >
          {{ heating.type.total }}
        </li>
      </ul>
      <ul class="form__list form__list-top" v-if="heating.type.value == 2">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.central_heating_surface
          }}
        </li>

        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            @input="countHeatingPoints"
            v-model="heating.central_heating.value"
            name="heating[central_heating]"
            label=""
            :IsExtraInfo="true">
            <template
                slot="extra-info"                  
                >{{ heating.central_heating.total }}
            </template>
          </v-numeric-field-public>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes" v-if="heating.type.value == 2">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.thermostat_buttons
          }}
        </li>

        <li class="form__item form__item--checkboxes-extra-info form__item--1/4">
          <input type="hidden" name="heating[thermostat]" value="0" />
          <v-checkboxes-public
            id="heatingThermostat"
            @input="countHeatingPoints"
            label=""
            :is-single-checkbox="true"
            name="heating[thermostat]"
            v-model="heating.thermostat.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          {{ heating.thermostat.total }}
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.heated_private_rooms
          }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="heating.total"
            name="heating[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>

    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        3.
        {{
          locales &&
          locales.properties &&
          locales.properties.kitchen_facilities_sanitary
        }}
      </template>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.kitchen }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="kitchenFacilities.kitchen.value"
                name="kitchen_facilities[kitchen]"
                :options="kitchenOptions"
                @input="countKitchenFacilitiesPoints"
            ></v-radios-public>
            <strong
                v-if="kitchenFacilities.kitchen.value"
                >{{ kitchenFacilities.kitchen.total }}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.wc }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="kitchenFacilities.wc.value"
                name="kitchen_facilities[wc]"
                :options="wcOptions"
                @input="countKitchenFacilitiesPoints"
            ></v-radios-public>
            <strong v-if="kitchenFacilities.wc.value">
              {{kitchenFacilities.wc.total}}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.bath_shower }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="kitchenFacilities.bath_shower.value"
                name="kitchen_facilities[bath_shower]"
                :options="bathShowerOptions"
                @input="countKitchenFacilitiesPoints"
            ></v-radios-public>
            <strong v-if="kitchenFacilities.bath_shower.value">
              {{kitchenFacilities.bath_shower.total}}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.washbasin }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="kitchenFacilities.washbasin.value"
                name="kitchen_facilities[washbasin]"
                :options="washbasinOptions"
                @input="countKitchenFacilitiesPoints"
            ></v-radios-public>
            <strong v-if="kitchenFacilities.washbasin.value">
              {{kitchenFacilities.washbasin.total}}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.kitchen_facilities_sanitary
          }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="kitchenFacilities.total"
            name="kitchen_facilities[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        4.
        {{ locales && locales.properties && locales.properties.extra_points }}
      </template>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales && locales.properties && locales.properties.outdoor_space
          }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="extraPoints.outdoor_space.value"
                name="extra_points[outdoor_space]"
                :options="outdoorSpaceOptions"
                @input="countExtraPoints"
            ></v-radios-public>
            <strong v-if="extraPoints.outdoor_space.value">
              {{extraPoints.outdoor_space.total}}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list--radios form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.bicycle_shed }}
        </li>
        <li class="form__item">
            <v-radios-public
                v-model="extraPoints.bicycle_shed.value"
                name="extra_points[bicycle_shed]"
                :options="bicycleShedOptions"
                @input="countExtraPoints"
            ></v-radios-public>
            <strong v-if="extraPoints.bicycle_shed.value">
              {{extraPoints.bicycle_shed.total}}
            </strong>
        </li>
      </ul>
      <ul class="form__list form__list-top form__list--checkboxes">
        <li
          class="form__item form__item--1/4"
          v-html="
            locales &&
            locales.properties &&
            locales.properties.is_national_monument
          "
        ></li>

        <li class="form__item form__item--checkboxes-extra-info form__item--1/8">
          <input
            type="hidden"
            name="extra_points[national_monument]"
            value="0"
          />
          <v-checkboxes-public
            id="extraPointsNationalMonument"
            @input="countExtraPoints"
            label=""
            :is-single-checkbox="true"
            name="extra_points[national_monument]"
            v-model="extraPoints.national_monument.value"
            :options="{ '1': '' }"
          >
          </v-checkboxes-public>
          {{ extraPoints.national_monument.total }}
        </li>
      </ul>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{ locales && locales.properties && locales.properties.extra_points }}
          {{ locales && locales.common && locales.common.total }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="extraPoints.total"
            name="extra_points[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }">
      <template slot="header">
        5.
        {{
          locales && locales.properties && locales.properties.deduction_points
        }}
      </template>
      <template v-for="(deduction, index) in deductionOptions">
        <ul class="form__list form__list-top form__list--checkboxes" v-if="index != 'total'" :key="index">
          <li
            class="form__item form__item--1/4"
            v-html="locales && locales.properties && locales.properties[index]"
          ></li>
  
          <li class="form__item form__item--checkboxes-extra-info form__item--1/8">
            <input
              type="hidden"
              :name="`deduction_points[` + index + `]`"
              value="0"
            />
            <v-checkboxes-public
              :id="`deductionOptions`+index"
              @input="countDeductionPoints"
              label=""
              :is-single-checkbox="true"
              :name="`deduction_points[` + index + `]`"
              v-model="deductionOptions[index].value"
              :options="{ '1': '' }"
            >
            </v-checkboxes-public>
            {{ deductionOptions[index].total }}
          </li>
        </ul>
      </template>
      <ul class="form__list form__list-top">
        <li class="form__item form__item--1/4">
          {{
            locales &&
            locales.properties &&
            locales.properties.deduction_points_total
          }}
        </li>
        
        <li class="form__item form__item--1/4">
          <v-numeric-field-public
            v-model="deductionOptions.total"
            name="deduction_points[total]"
            label=""
          >
          </v-numeric-field-public>
        </li>
      </ul>
    </v-card>
    <v-card :is-open-responsive="{ desktop: true, mobile: true }" class="v-card--total v-card--sticky">
      <template slot="header">
        {{ locales && locales.properties && locales.properties.total_points }}
      </template>

    <ul class="form__list">
        <li class="form__item form__item--total form__item--1/2">
            <ul class="form__list">
                <li class="form__item form__item--1/2">
                    {{ locales && locales.properties && locales.properties.total_points }}
                </li>
                <li class="form__item form__item--1/2">
                    <v-numeric-field-public v-model="totalPoints" name="total" label="">
                      </v-numeric-field-public>
                </li>
            </ul>
        </li>
        <li class="form__item form__item--total form__item--1/2">
            <ul class="form__list">
                <li class="form__item form__item--1/2">
                    {{
                        locales &&
                        locales.properties &&
                        locales.properties.max_basic_rent_price
                    }}
                </li>
                <li class="form__item form__item--1/2">
                    <v-numeric-field-public v-model="price" name="price" label="">
                      </v-numeric-field-public>
                </li>
            </ul>
        </li>
    </ul>
    <ul class="form__list form__list-top">
        <li class="form__item form__item__btns-wrap">
            <button type="submit" class="form__button" style="margin-right:15px;">
                {{ locales && locales.common && locales.common.download_pdf }}
            </button>
            <button type="submit" name="submit" value="save" class="form__button">
                {{ locales && locales.common && locales.common.save }}
            </button>
        </li>
      </ul>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
export default {
  computed: {
    ...mapGetters(["metadata", "locales"]),
  },
  data() {
    return {
      total: 0,
      totalPoints: 0,
      surface: 0,
      price: 0,
    };
  },
  props: {
    property: {
      default: () => {
        return {};
      },
      type: Object,
    },
    kitchenFacilities: {
      default: () => {
        return {};
      },
      type: Object,
    },
    extraPoints: {
      default: () => {
        return {};
      },
      type: Object,
    },
    leaveArea: {
      default: () => {
        return {};
      },
      type: Object,
    },
    heating: {
      default: () => {
        return {};
      },
      type: Object,
    },
    dependantMaxRentalPrices: {
      default: () => {
        return {};
      },
      type: [Array, Object],
    },
    dependantSettings: {
      default: () => {
        return {};
      },
      type: [Array, Object],
    },
    kitchenOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    wcOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    bathShowerOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    washbasinOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    outdoorSpaceOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    bicycleShedOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
    deductionOptions: {
      default: () => {
        return {};
      },
      type: Object,
    },
  },
  beforeMount() {
    this.countDependantLeaveAreaPoints(this.leaveArea);
    this.countHeatingPoints();
    this.countKitchenFacilitiesPoints();
    this.countExtraPoints();
    this.countDeductionPoints();
  },
  methods: {
    countDependantLeaveAreaPoints(object) {
      var sum = 0;
      var commonAreaPoints = 0;
      var commonAreaSurface = 0;
      if (object["own_room"].surface) {
        sum +=
          Math.round(
            parseFloat((object["own_room"].surface + "").replace(",", "."))
          ) * parseFloat((this.dependantSettings.price_points_settings.dependant_leave_area.own_room_points_per_m2 + "").replace(",", "."));
      }
      if (
        object["common_area"].surface &&
        object["common_area"].surface >= 15
      ) {
        commonAreaSurface += Math.round(
          parseFloat((object["common_area"].surface + "").replace(",", "."))
        );
      }

      if (object["number_of_residents"] && object["number_of_residents"] >= 1) {
        commonAreaPoints =
          Math.round(
            commonAreaSurface /
              parseFloat((object["number_of_residents"] + "").replace(",", "."))
          ) * parseFloat((this.dependantSettings.price_points_settings.dependant_leave_area.common_area_points_per_m2 + "").replace(",", "."));
        sum += commonAreaPoints;
      }
      var total = sum;
      Vue.set(object, "total", total);
      this.countDependantTotal();
    },
    countHeatingPoints() {
      var sum = 0;
      var heatingPoints = 0;
      Vue.set(this.heating.type, "total", heatingPoints);
      if (this.heating.type.value == 1) {
        heatingPoints = parseFloat((this.dependantSettings.price_points_settings.dependant_heating.gas_heater + "").replace(",", "."));
        Vue.set(this.heating.type, "total", heatingPoints);
        sum += heatingPoints;
      } else if (this.heating.type.value == 2) {
        heatingPoints =
          parseFloat(this.heating.central_heating.value + "") *
          parseFloat(this.heating.central_heating.points + "");
        sum += heatingPoints;
        Vue.set(this.heating.central_heating, "total", heatingPoints);
        if (
          this.heating.thermostat.value &&
          this.heating.thermostat.value == 1
        ) {
          sum += parseFloat(this.heating.thermostat.points + "");
          Vue.set(
            this.heating.thermostat,
            "total",
            parseFloat(this.heating.thermostat.points + "")
          );
        } else {
          Vue.set(this.heating.thermostat, "total", 0);
        }
      }
      var total = sum;
      Vue.set(this.heating, "total", total);
      this.countDependantTotal();
    },
    countKitchenFacilitiesPoints() {
      var sum = 0;

      switch (this.kitchenFacilities.kitchen.value) {
        case "1":
          Vue.set(this.kitchenFacilities.kitchen, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.kitchen.kitchen_for_max_5_rooms + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.kitchen, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.kitchen.own_kitchen_in_common_room + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.kitchen, "total", points);
          sum += points;
          break;
        case "4":
          var points = parseFloat((this.dependantSettings.price_points_settings.kitchen.own_kitchen_in_living_room_15_25 + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.kitchen, "total", points);
          sum += points;
          break;
        case "5":
          var points = parseFloat((this.dependantSettings.price_points_settings.kitchen.own_kitchen_in_living_room_above_25 + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.kitchen, "total", points);
          sum += points;
          break;
        case "6":
          var points = parseFloat((this.dependantSettings.price_points_settings.kitchen.separate_private_kitchen + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.kitchen, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.kitchenFacilities.kitchen, "total", 0);
      }
      switch (this.kitchenFacilities.wc.value) {
        case "1":         
          Vue.set(this.kitchenFacilities.wc, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.communal_toilet_for_max_5_rooms + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.wc, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.own_toilet + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.wc, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.kitchenFacilities.wc, "total", 0);
      }
      switch (this.kitchenFacilities.bath_shower.value) {
        case "1":
          Vue.set(this.kitchenFacilities.bath_shower, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.communal_shower_bath_for_max_8_rooms + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.bath_shower, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.private_shower_bath + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.bath_shower, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.kitchenFacilities.bath_shower, "total", 0);
      }
      switch (this.kitchenFacilities.washbasin.value) {
        case "1":
          Vue.set(this.kitchenFacilities.washbasin, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.communal_washbasin_for_max_5_rooms + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.washbasin, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.sanitary.own_sink + "").replace(",", "."));
          Vue.set(this.kitchenFacilities.washbasin, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.kitchenFacilities.washbasin, "total", 0);
      }
      var total = sum;
      Vue.set(this.kitchenFacilities, "total", total);
      this.countDependantTotal();
    },
    countExtraPoints() {
      var sum = 0;

      switch (this.extraPoints.outdoor_space.value) {
        case "1":
          Vue.set(this.extraPoints.outdoor_space, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.communal_outdoor_space_below_4 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        case "5":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.private_outdoor_space_below_4 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.communal_outdoor_space_4_10 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        case "4":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.communal_outdoor_space_above_10 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        case "6":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.private_outdoor_space_4_10 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        case "7":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.private_outdoor_space_above_10 + "").replace(",", "."));
          Vue.set(this.extraPoints.outdoor_space, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.extraPoints.outdoor_space, "total", 0);
      }
      switch (this.extraPoints.bicycle_shed.value) {
        case "1":
          Vue.set(this.extraPoints.bicycle_shed, "total", 0);
          sum += 0;
          break;
        case "2":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.communal_bicycle_shed + "").replace(",", "."));
          Vue.set(this.extraPoints.bicycle_shed, "total", points);
          sum += points;
          break;
        case "3":
          var points = parseFloat((this.dependantSettings.price_points_settings.outdoor.private_bicycle_shed + "").replace(",", "."));
          Vue.set(this.extraPoints.bicycle_shed, "total", points);
          sum += points;
          break;
        default:
          Vue.set(this.extraPoints.bicycle_shed, "total", 0);
      }
      if (
        this.extraPoints.national_monument.value &&
        this.extraPoints.national_monument.value == 1
      ) {
        sum += parseFloat(this.extraPoints.national_monument.points + "");
        Vue.set(
          this.extraPoints.national_monument,
          "total",
          parseFloat(this.extraPoints.national_monument.points + "")
        );
      } else {
        Vue.set(this.extraPoints.national_monument, "total", 0);
      }
      var total = sum;
      Vue.set(this.extraPoints, "total", total);
      this.countDependantTotal();
    },
    countDeductionPoints() {
      var sum = 0;

      for (var ob in this.deductionOptions) {
        if (ob != "total") {
          if (this.deductionOptions[ob].value && parseFloat(this.deductionOptions[ob].value + "")) {
            sum += parseFloat(this.deductionOptions[ob].points + "");
            Vue.set(
              this.deductionOptions[ob],
              "total",
              parseFloat(this.deductionOptions[ob].points + "")
            );
          } else {
            Vue.set(this.deductionOptions[ob], "total", 0);
          }
        }
      }
      var max =
        (this.leaveArea.total +
          this.heating.total +
          this.kitchenFacilities.total +
          this.extraPoints.total) /
        2;
        if (Math.abs(sum) >= Math.abs(max)) {
          sum = -max;
        }
        var total = sum;
        Vue.set(this.deductionOptions, "total", total);
        this.countDependantTotal();
      },
    countDependantTotal() {
        var total =
        parseFloat(this.leaveArea.total+"") +
        parseFloat(this.heating.total+"") +
        parseFloat(this.kitchenFacilities.total+"") +
        parseFloat(this.extraPoints.total+"") +
        parseFloat(this.deductionOptions.total+"");
      this.total = Math.round(total);
      this.totalPoints = this.total;
      var p = this.totalPoints < 750 ? this.totalPoints : 750;
      this.price = this.dependantMaxRentalPrices[p];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DependantForm.vue